import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { ModalComponent } from '../../layout/modals/ModalComponent';
import { FormField } from '../../layout/form-fields/FormField';
import { industryStore } from './IndustryStore';

const ValidationSchema = Yup.object().shape({
	name: Yup.string().required().label('Name')
});

export class IndustryEdit extends ModalComponent {
	render() {
		return (
			<Formik
				initialValues={{
					name: this.props.industry.name
				}}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.save(values);
				}}>
				{formikBag => this.renderModalContainer(formikBag, 'IndustryEdit')}
			</Formik>
		);
	}

	renderForm(formikBag) {
		return (
			<div className="columns">
				<div className="column is-full">
					<FormField
						required
						className="has-text-left"
						label="Name"
						field="name"
						type="text"
						placeholder="Name"
					/>
				</div>
			</div>
		);
	}

	async save(values) {
		industryStore
			.update(this.props.industry.id, {
				industry: { name: values.name.trim() }
			})
			.then(result => {
				this.resultNotification(result, 'Industry', 'Edit');
			});
	}
}
